import { render, staticRenderFns } from "./EditPermissionModal.vue?vue&type=template&id=9ed79722&"
import script from "./EditPermissionModal.vue?vue&type=script&lang=js&"
export * from "./EditPermissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports